var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-md-flex flex-column",attrs:{"id":"app"}},[(!_vm.embedded)?_c('Header',{on:{"ChangeLanguage":_vm.changeSiteLanguage}}):_vm._e(),_c('router-view'),(!_vm.embedded)?_c('Footer',{on:{"ChangeLanguage":_vm.changeSiteLanguage}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }